// extracted by mini-css-extract-plugin
export default {"dash":"SortCodeInput_dash__QWQ43","field":"SortCodeInput_field__tsXdU","fields":"SortCodeInput_fields__Ijqgu"};